import client from '@libs/HttpClient';
class JobPositionService {
  static listJobPosition(request) {
    const page_no = request.queryKey[1];
    const searchText = request.queryKey[2];
    const status = request.queryKey[3];

    return client.get(
      `/job-position/?search=${searchText}&page=${page_no}&status=${status}`,
      request
    );
  }

  static addJobPosition(request) {
    return client.post('/job-position', request);
  }

  static showJobPosition(params) {
    return client.get(`/job-position/${params}`);
  }

  static viewJobPosition(params) {
    return client.get(`/job-position/${params}/edit`);
  }

  static updateJobPosition(request) {
    return client.put(`/job-position/${request.id}`, request);
  }

  static deleteJobPosition(request) {
    return client.delete(`/job-position/${request.id}`, request);
  }

  static changeStatusJobPosition(request) {
    return client.patch(`/job-position/change-status/${request.id}`, request);
  }
}
export { JobPositionService };
